import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import OtherEquipmentDetail from '../../components/other_equipments/OtherEquipmentDetail';
import { createOtherEquipment } from '../../redux/other_equipment/equipment_actions';

class OtherEquipmentCreateModal extends React.Component {
  constructor(props) {
    super(props);
    this.otherEquipmentDetail = undefined;
    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };
  }

  onSaveHandler() {
    const newEquipment = this.otherEquipmentDetail.getWrappedInstance().getOtherEquipmentData();
    this.props.createOtherEquipment(newEquipment);
  }

  render() {
    const { isCreating, errorMessage, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;

    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-lg">
            {t('create other equipment')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <OtherEquipmentDetail
            ref={ref => (this.otherEquipmentDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isCreating && !this.props.isCreated && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="other-equipment-submit-create"
            disabled={!isSubmittable || isCreating}
            onClick={() => this.onSaveHandler()}
          >
            {this.props.isCreating ? `${t('creating')}...` : t('create')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const otherEquipmentState = state.other_equipment;
  return {
    errorMessage: otherEquipmentState.errorMessage,
    isCreating: otherEquipmentState.isCreating,
  };
};

const mapDispatchToProps = dispatch => ({
  createOtherEquipment: equipment =>
    dispatch(
      createOtherEquipment(
        equipment.name,
        equipment.power_required,
        equipment.description || '',
        equipment.image,
        equipment.cfp_value,
        equipment.cfp_unit,
      ),
    ),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(OtherEquipmentCreateModal)
);



// WEBPACK FOOTER //
// ./src/modal/other_equipments/OtherEquipmentCreateModal.js